import {lazy} from 'react';
import {type RouteObject} from 'react-router-dom';

import {ProtectedRoute} from './ProtectedRoute';
import {
  learnerPortalRoles,
  CERTIFICATE_READ,
  OPTIX_ACADEMY_LEARNER_READ,
  QUALIFICATIONS_READ,
  SKILLS_PROGRAMS_READ,
  TRAINING_COURSE_READ,
} from '../modules/common/constants/roles';
import {routes} from '../modules/common/constants/routes';
import {
  type Breadcrumb,
  breadcrumbLoaderFunction,
} from '../modules/common/stores/breadcrumbStore';

const LearnerPortalViewCourse = lazy(
  async () => await import('../modules/learnerPortal/pages/ViewCourse'),
);
const LearnerPortalLearnerOverview = lazy(
  async () => await import('../modules/learnerPortal/pages/LearnerOverview'),
);
const LearnerPortalCourses = lazy(
  async () => await import('../modules/learnerPortal/pages/Courses'),
);
const LearnerPortalSkillsProgrammes = lazy(
  async () => await import('../modules/learnerPortal/pages/SkillsProgrammes'),
);
const LearnerPortalQualifications = lazy(
  async () => await import('../modules/learnerPortal/pages/Qualifications'),
);
const LearnerPortalCertificates = lazy(
  async () => await import('../modules/learnerPortal/pages/Certificates'),
);

const baseLearnerPortalBreadcrumbs: Breadcrumb[] = [
  {label: 'Learner Portal', path: routes.learnerPortal.get()},
];

export const learnerPortalChildren: RouteObject[] = [
  {
    path: '',
    element: (
      <ProtectedRoute roles={learnerPortalRoles}>
        <LearnerPortalLearnerOverview />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([{label: 'Learner Portal'}]),
  },
  {
    path: routes.learnerPortal.overview,
    element: (
      <ProtectedRoute roles={learnerPortalRoles}>
        <LearnerPortalLearnerOverview />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseLearnerPortalBreadcrumbs,
      {label: 'Overview'},
    ]),
  },

  {
    path: routes.learnerPortal.courses,
    element: (
      <ProtectedRoute
        roles={[OPTIX_ACADEMY_LEARNER_READ, TRAINING_COURSE_READ]}
      >
        <LearnerPortalCourses />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseLearnerPortalBreadcrumbs,
      {label: 'Courses'},
    ]),
  },
  {
    path: routes.learnerPortal.skillsProgrammes,
    element: (
      <ProtectedRoute
        roles={[OPTIX_ACADEMY_LEARNER_READ, SKILLS_PROGRAMS_READ]}
      >
        <LearnerPortalSkillsProgrammes />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseLearnerPortalBreadcrumbs,
      {label: 'Skills Programmes'},
    ]),
  },
  {
    path: routes.learnerPortal.qualifications,
    element: (
      <ProtectedRoute roles={[OPTIX_ACADEMY_LEARNER_READ, QUALIFICATIONS_READ]}>
        <LearnerPortalQualifications />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseLearnerPortalBreadcrumbs,
      {label: 'Qualifications'},
    ]),
  },
  {
    path: routes.learnerPortal.certificates,
    element: (
      <ProtectedRoute roles={[OPTIX_ACADEMY_LEARNER_READ, CERTIFICATE_READ]}>
        <LearnerPortalCertificates />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseLearnerPortalBreadcrumbs,
      {label: 'Certificates'},
    ]),
  },
  {
    path: routes.learnerPortal.viewCourse,
    element: (
      <ProtectedRoute
        roles={[OPTIX_ACADEMY_LEARNER_READ, TRAINING_COURSE_READ]}
      >
        <LearnerPortalViewCourse />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseLearnerPortalBreadcrumbs,
      {label: 'View Course'},
    ]),
  },
];
